module.exports = __webpack_public_path__ + "static/media/block-3-beenleigh.61e101ae.png";